<template>
  <div class="card is-min-width-700">
    <header class="bandeau-modal card-header">
    </header>
    <div class="center">
      <div class="columns is-gapless">
        <div class="column mgt-40px">
          <h1 class="title is-size-3">
            {{ $t('ajoutEditContrat.echeancier.popUpAjoutEcheancierManuel.title') }}
          </h1>
        </div>
      </div>
    </div>
    <div class="card-content ">
      <div class="columns is-multiline">
        <div class="column is-12">
          <b-field
            :label="$t('ajoutEditContrat.echeancier.popUpAjoutEcheancierManuel.bailleur')">
            <b-select v-model="tiersId" expanded>
              <option v-for="unitBailleur in bailleurs" :value="unitBailleur.tiersId"
                      :key="unitBailleur.tiersId">
                {{ unitBailleur.libelle }}
              </option>
            </b-select>
          </b-field>
        </div>
      </div>
      <footer>
        <b-field>
          <div class="is-pulled-left boutonAction">
            <a class="button" @click="$parent.close()">
              {{ $t('general.button.cancel')}}
            </a>
          </div>
          <div class="is-pulled-left boutonAction">
            <a class="button is-addOrEdit" @click="save">
              {{ $t('general.button.add') }}
            </a>
          </div>
        </b-field>
      </footer>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    bailleurs: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      tiersId: null,
    };
  },
  methods: {
    save() {
      this.$emit('bailleurSelected', this.tiersId);
      this.$parent.close();
    },
  },
};
</script>
